/**
 * Format-agnostic amount search.
 *
 * Accepts queries like "37.77", "37,77", "-37,77", "37.77 zł", "37,7" and
 * matches them against any numeric amount via prefix on the absolute,
 * 2-decimal string form. Sign and currency symbols in the query are ignored.
 */

/** Returns a normalized numeric prefix (e.g. "37.7") or null for non-numeric queries. */
export function normalizeAmountQuery(raw: string): string | null {
  const stripped = raw
    .replace(/\s+/g, '')
    .replace(/zł|kč|€|\$|£/gi, '')
    .replace(/^-/, '')
    .replace(/,/g, '.')
  if (stripped.length === 0) return null
  if (!/^\d+(\.\d*)?$/.test(stripped)) return null
  return stripped
}

/** Prefix-match a numeric amount against a normalized query (from normalizeAmountQuery). */
export function matchesAmount(amount: number, normalizedQuery: string): boolean {
  const key = Math.abs(amount).toFixed(2)
  return key.startsWith(normalizedQuery)
}
